import { DealerLocatorModalWrapper } from './dealer-locator-modal-wrapper';
import { DealerLocatorContent } from './dealer-locator-content';
import { StoreAddress } from './types';
import { TranslationsProvider } from 'providers/translations-provider';
import { dealerLocatorDrawerTranslationKeys } from './constants/translation-keys';
import { OrderItemSavedList } from 'services/savedLists/types';

interface DealerLocatorModalProps {
  autoSearch?: boolean;
  isRegistration?: boolean;
  storeAddress?: StoreAddress;
  isWelcomeModal?: boolean;
  restrictedDealerStores?: string[];
  isCatCSR?: boolean;
  redirectionUrl?: string;
  savedList?: OrderItemSavedList[];
}

export const DealerLocatorModal = ({
  autoSearch = false,
  isRegistration = false,
  storeAddress,
  isWelcomeModal = false,
  restrictedDealerStores,
  isCatCSR = false,
  redirectionUrl = '',
  savedList = []
}: DealerLocatorModalProps) => {
  return (
    <TranslationsProvider keys={dealerLocatorDrawerTranslationKeys}>
      <DealerLocatorModalWrapper isWelcomeModal={isWelcomeModal}>
        <DealerLocatorContent
          autoSearch={autoSearch}
          isModal
          isRegistration={isRegistration}
          storeAddress={storeAddress}
          isWelcomeModal={isWelcomeModal}
          restrictedDealerStores={restrictedDealerStores}
          isCatCSR={isCatCSR}
          redirectionUrl={redirectionUrl}
          savedList={savedList}
        />
      </DealerLocatorModalWrapper>
    </TranslationsProvider>
  );
};
